// extracted by mini-css-extract-plugin
module.exports = {"block":"BillingQuestion_style_block__jTiSF"};